import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ClassRecord } from '../../data/classes';
import { ClassCard } from './ClassCard';
interface DayClassesDrawerProps {
  date: string | null;
  classes: ClassRecord[];
  isOpen: boolean;
  onClose: () => void;
  onClassClick: (classRecord: ClassRecord) => void;
}
export function DayClassesDrawer({
  date,
  classes,
  isOpen,
  onClose,
  onClassClick
}: DayClassesDrawerProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!date) return null;
  const formattedDate = new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return <AnimatePresence data-id="element-162">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-40 transition-opacity" aria-hidden="true" data-id="element-163" />

          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-y-0 right-0 w-full max-w-md bg-gray-50 shadow-xl z-40 flex flex-col overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="day-drawer-title" data-id="element-164">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-white" data-id="element-165">
              <div data-id="element-166">
                <h2 id="day-drawer-title" className="text-lg font-bold text-gray-900" data-id="element-167">
                  Classes on
                </h2>
                <p className="text-sm text-brand-purple-600 font-medium" data-id="element-168">
                  {formattedDate}
                </p>
              </div>
              <button onClick={onClose} className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-purple-500" aria-label="Close panel" data-id="element-169">
                <X className="w-5 h-5" data-id="element-170" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-171">
              {classes.length === 0 ? <p className="text-gray-500 text-center py-8" data-id="element-172">
                  No classes scheduled for this day.
                </p> : classes.map(cls => <ClassCard key={cls.id} classRecord={cls} onClick={c => {
            // We don't close this drawer, just open the detail drawer over it
            onClassClick(c);
          }} data-id="element-173" />)}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}